((L, D, E, H, U) => {
	'use strict';

	const entries = [];
	const order = [];

	let index = 0;
	let top = 0;

	let settings = {};
	let root = '';

	let pending = null;
	let previous;

	let uri;

	/**
	 * Listen for browser navigation
	 *
	 * @private
	 */
	const _listen = () => {
		try {
			H.scrollRestoration = 'manual';
		} catch (e) {
			//
		}

		L._win.addEventListener('popstate', e => {
			let full;

			try {
				if (! e.state) {
					return;
				}

				full = L.routes.parse().full;

				if (uri.full === full) {
					return;
				}

				const current = entries[full];

				if (! current) {
					L._loc.href = full;

					return;
				}

				const value = e.state.index;
				const obj = L.$copy(current);

				obj.browser = true;
				obj.event = value < index ?
					'pop' : 'push';
				obj.index = value;
				obj.path = full;
				obj.partials = entries[order[index].full].partials;

				// Restore previous scroll position
				obj.scrollTop = current.top || 0;

				L.history.go(obj);

				index = value;
			} catch (e) {
				L._loc.href = full;
			}
		});
	};

	/**
	 * Process the state of the request
	 *
	 * @private
	 * @param {Object} conf
	 * @param {Object} options
	 */
	const _process = (conf, options) => {
		const direction = conf.event === 'push' ?
			1 : -1;
		const obj = {
			args: [
				{
					dir: direction,
					path: conf.route.path,
					prev: uri.path,
					conf: conf
				}
			]
		};

		if (conf.action) {
			L.events.trigger(L._win, 'pop', {
				conf: conf,
				path: uri.path
			});
		}

		if (conf.run) {
			L.routes.run({
				path: conf.route.path
			});
		}

		if (conf.action) {
			L.events.trigger(L._win, 'push', {
				conf: conf,
				path: conf.route.path
			});
		}

		if (conf.event) {
			pending = null;

			uri = conf.route;
		}

		L.$exec([
			settings.end,
			options.end
		], obj);
	};

	/**
	 * Return current path
	 *
	 * @private
	 * @param {Object} [loc]
	 * @returns {String}
	 */
	const _path = loc => {
		loc = loc || L._loc;

		return loc.pathname + loc.search + loc.hash;
	};

	/**
	 * Get top position
	 *
	 * @param {Object} [conf]
	 * @returns {number}
	 * @private
	 */
	const _top = conf => {
		top = (L.$(conf.scrollTarget)[0] || L._doc.scrollingElement).scrollTop;

		if (top < 140) {
			top = 0;
		}

		return top;
	};

	L.history = {
		/**
		 * Set the initial state and bind events
		 *
		 * @param {Object} [options]
		 * @param {$|boolean|HTMLElement|String} [options.bind]
		 * @param {Boolean} [options.scrollEarly=false]
		 * @param {String} [options.partials='title,main']
		 * @param {Boolean} [options.processErrors=false]
		 * @param {Boolean} [options.push=true]
		 * @param {Object} [options.request]
		 * @param {Boolean} [options.run=true]
		 * @param {Boolean} [options.useResponseURL=true]
		 */
		init(options) {
			const scope = this;

			if (scope.request) {
				return;
			}

			settings = Object.assign({
				partials: 'title, main',
				request: {},
				run: true,
				scrollTarget: L._doc.scrollingElement,
				scrollTop: 0
			}, options);

			root = settings.request.root || '';

			scope.request = settings.request;

			delete settings.request;

			// Set the current state
			uri = L.routes.uri();

			order.push(uri);

			entries[uri.full] = settings;

			try {
				H.replaceState({
					index: 0,
					top: 0
				}, '', uri.raw);

				_listen();

				scope.bind();
			} catch (e) {
				//
			}
		},

		/**
		 * Determine if the path is navigable
		 *
		 * @private
		 * @param {HTMLElement} el
		 * @returns {Boolean}
		 */
		validate(el) {
			return ! (
				! el.href ||
				el.target === '_blank' ||
				! /https?:/.test(el.href) ||
				el.hasAttribute('download') ||
				el.hasAttribute('data-static') ||
				(el.hostname && el.hostname !== L._loc.hostname) ||
				(el.hash && el.pathname === uri.path)
			);
		},

		/**
		 * Bind element events
		 */
		bind() {
			const scope = this;

			E.on('a', 'click', (e, el) => {
				if (e.metaKey) {
					return;
				}

				if (! scope.validate(el)) {
					return;
				}

				try {
					scope.go({
						path: _path(el)
					});

					e.preventDefault();
					e.stopPropagation();
				} catch (e) {
					//
				}
			}, {
				delegate: L._body,
				namespace: 'history'
			});
		},

		/**
		 * Get index
		 *
		 * @returns {Number}
		 */
		index() {
			return index;
		},

		/**
		 * Get pending entry
		 *
		 * @returns {Object}
		 */
		pending() {
			return pending;
		},

		/**
		 * Get entry
		 *
		 * @param {Boolean|Number} [offset]
		 * @returns {Object}
		 */
		get(offset) {
			if (offset === U) {
				return order;
			}

			if (offset === true) {
				return pending ?
					pending.route : null;
			}

			return order[index + offset];
		},

		/**
		 * Add entry
		 *
		 * @param {Object} conf
		 */
		push(conf) {
			if (! conf.event) {
				return;
			}

			if (! conf.browser) {
				entries[conf.route.full] = conf;

				if (conf.route.full !== uri.full) {
					index = conf.index;

					H.pushState({
						index: index
					}, '', conf.route.raw);

					order[index] = conf.route;
				}
			}

			// Set route
			L.routes.set(conf.route, true);

			// Update document title
			if (conf.title) {
				L._doc.title = conf.title;
			}
		},

		/**
		 * Replace current state
		 *
		 * @param {Object|String} value
		 */
		replace(value) {
			const current = order[index].full;

			uri = L.routes.set(value, true);

			if (uri.full === current) {
				return;
			}

			order[index] = L.$copy(uri);

			if (entries[current]) {
				const entry = entries[current];

				delete entries[current];

				if (entry.route) {
					entry.route = order[index];
				}

				entry.top = _top(order[index]);

				entries[uri.full] = entry;
			}

			try {
				H.replaceState({
					index: index
				}, '', uri.raw);
			} catch (e) {
				//
			}
		},

		/**
		 * Navigate to a new path or direction
		 *
		 * @param {Object|String} options
		 * @param {Boolean|String} [options.action='replace'] append or replace response, false to mock
		 * @param {Boolean|String} [options.event='push'] push, pop, or false
		 * @param {String} [options.partials='title,main']
		 * @param {String} [options.path=current]
		 * @param {Boolean} [options.push=true]
		 * @param {Boolean|Object} [options.request]
		 * @param {Boolean} [options.run=true] execute routes
		 * @param {*} [options.scrollTarget=document]
		 * @param {*} [options.scrollTop]
		 * @param {String} [options.title]
		 * @returns {*}
		 */
		go(options) {
			const scope = this;

			if (! scope.request) {
				scope.init();
			}

			if (typeof options === 'string') {
				options = {
					path: options
				};
			}

			const conf = Object.assign(L.$copy(settings), {
				action: 'replace',
				event: 'push'
			}, options);

			conf.index = index + (
				conf.event === 'push' ?
					1 : -1
			);

			conf.route = conf.route && typeof conf.route === 'object' ?
				conf.route : L.routes.parse(conf.route || conf.path);

			if (pending && conf.browser === U) {
				conf.browser = pending.browser;
			}

			const request = conf.request || {};

			request.root = request.root !== U ?
				request.root : root;

			request.url = request.url !== U ?
				request.url : conf.path;

			const route = L.routes && conf.run;

			if (! conf.force) {
				const a = L._doc.createElement('a');

				a.href = request.root + request.url;

				// Navigate to external URL
				if (! scope.validate(a)) {
					L._loc.href = request.url;

					return null;
				}
			}

			const prev = L.$copy(uri);

			let parsed = L.routes.parse(request.url);

			request.url = parsed.raw;

			conf.request = request;

			let aborted = false;

			conf.abort = () => {
				aborted = true;
			};

			pending = conf;

			// Precalculate position to mitigate Chrome performance issue
			top = _top(conf);

			if (
				(
					previous &&
					L.$exec(previous.unload, {
						args: [
							conf,
							previous
						]
					}) === false
				) ||
				L.$exec(settings.begin, {
					args: conf
				}) === false || (
					settings.begin !== options.begin &&
					L.$exec(options.begin, {
						args: conf
					}) === false
				)
			) {
				uri = prev;
				pending = null;

				return null;
			}

			previous = conf;

			// Evaluate preload routes against target path
			if (route) {
				L.routes.run({
					event: 'preload',
					path: request.url
				});
			}

			L.events.trigger(L._win, 'preload', {
				conf: conf,
				path: request.url
			});

			if (aborted) {
				uri = prev;
				pending = null;

				if (conf.abort) {
					L.$exec(conf.abort);
				}

				return;
			}

			if (conf.event) {
				uri = L.routes.set(uri, true);

				if (entries[uri.full]) {
					entries[uri.full].top = top;
				}
			}

			const req = scope.request;
			const mock = conf.action === false;

			const completeEvents = [];
			const errorEvents = [];
			const sendEvents = [];

			const successEvents = [
				() => {
					scope.push(conf);
				}
			];

			// Send PJAX header
			if (! request.json) {
				request.headers = Object.assign({
					'x-pjax': true
				}, request.headers);
			}

			// Process send events
			if (request.send) {
				sendEvents.push(request.send);
			}

			if (req.send) {
				sendEvents.push(req.send);
			}

			request.send = sendEvents;

			const scrollEvent = data => {
				let stp = conf.scrollTop;

				if (stp === false) {
					return;
				}

				if (typeof stp === 'function') {
					stp = stp(conf, data);

					if (stp === false) {
						return;
					}
				}

				let top = 0;

				if (Number.isFinite(stp)) {
					top = stp;
				} else {
					if (conf.route && conf.route.hash) {
						stp = '#' + conf.route.hash;
					}

					const el = L.$first(stp);

					if (el) {
						try {
							top = el.getBoundingClientRect().top + L._win.scrollY;
						} catch (e) {
							top = 0;
						}
					}
				}

				let stg = conf.scrollTarget;

				if (typeof stg === 'function') {
					stg = stg(conf, data);
				}

				L.$each(stg, el => {
					el.scrollTop = top;
				});
			};

			// Compile success events
			const replaceEvent = x => {
				let html = x && x.responseText ?
					x.responseText : x;

				if (conf.replace) {
					const response = L.$exec(conf.replace, {
						args: [
							html,
							conf
						]
					});

					html = typeof response === 'string' ?
						response : html;
				}

				// Evaluate unload routes against current path
				if (route) {
					try {
						L.routes.run({
							event: 'unload',
							path: prev.path
						});

						L.events.trigger(L._win, 'unload', {
							conf: conf,
							path: prev.path
						});
					} catch (e) {
						//
					}
				}

				if (html === false) {
					return;
				}

				if (! mock && conf.partials) {
					html = L.$parseHTML('<i>' + html + '</i>').firstChild;

					conf.partials.split(',').forEach(partial => {
						const el = L.$(partial, html)[0];
						const target = L.$(partial)[0];

						if (el && target) {
							const parent = target.parentNode;

							if (conf.action === 'append') {
								parent.appendChild(el);
							} else {
								parent.replaceChild(el, target);
							}
						}
					});

					L.$setVar();
				}
			};

			if (conf.scrollEarly) {
				successEvents.push(scrollEvent);
			}

			if (! mock) {
				successEvents.push(replaceEvent);
			}

			if (! conf.scrollEarly) {
				successEvents.push(scrollEvent);
			}

			if (request.success) {
				successEvents.push(request.success);
			}

			if (req.success) {
				successEvents.push(req.success);
			}

			request.success = successEvents;

			// Compile error events
			if (request.error) {
				errorEvents.push(request.error);
			}

			if (req.error) {
				errorEvents.push(req.error);
			}

			// Optionally process error events
			if (conf.processErrors) {
				errorEvents.push(successEvents[0], replaceEvent, scrollEvent);
			}

			request.error = errorEvents;

			// Compile complete events
			if (request.complete) {
				completeEvents.push(request.complete);
			}

			if (req.complete) {
				completeEvents.push(req.complete);
			}

			if (! mock) {
				completeEvents.push(x => {
					const status = x.status;
					const url = x.responseURL;

					if (url) {
						parsed = L.routes.parse(url);

						conf.path = parsed.full;
					}

					if (conf.processErrors || (
						status >= 200 &&
						status < 400
					)) {
						_process(conf, options);
					}
				});
			}

			request.complete = completeEvents;

			// Make Ajax request
			request.args = request.args || [];

			if (mock) {
				L.$exec(sendEvents.concat(
					[successEvents[0]],
					completeEvents
				));

				_process(conf, options);
			} else {
				return D.request(request);
			}

			return null;
		}
	};
})(Apt, Apt.fetch, Apt.events, history, undefined);